import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { DashboardService } from '../dashboard.service';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import {
    Observable,
    Subject,
    Subscription,
    catchError,
    combineLatest,
    distinctUntilChanged,
    finalize,
    map,
    of,
    startWith,
    switchMap,
    takeUntil,
    tap,
} from 'rxjs';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { OperatorAccess, UserFunction } from 'src/app/platform/nomenclatoare/operatori/operatori.interface';
import { StorageService } from 'src/app/services/storage.service';
import { OperatoriService } from 'src/app/platform/nomenclatoare/operatori/operatori.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DocumentListDT, DocumentData, DocumentActivity, GeneralData, DocumentHistory, StoreDocResponse, FileDocument, FileUpload } from '../document.interface';
import { Colleague } from 'src/app/interfaces/common.interface';
import { DialogService } from 'src/app/services/dialog.service';
import { ModalInchidereLucrareComponent } from './modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { requireMinOneColleagueValidator } from 'src/app/validators/at-least-one-colleague';
import { CommonService } from 'src/app/services/common.service';
import { DocIntrareComponent } from '../doc-intrare/doc-intrare.component';
import { DocumentInternComponent } from '../doc-intern/document-intern.component';
import { DocumentIesireComponent } from '../doc-iesire/document-iesire.component';
import { ToastService } from 'src/app/services/toast.service';
import { EditInfoComponent } from './edit-info/edit-info.component';
import { AppFilesService } from 'src/app/services/app-files.service';
import { PermissionsService } from 'src/app/services/permissions.service';

import { BreakpointObserver } from '@angular/cdk/layout';

import { Generic, GenericEmail, GenericUser } from 'src/app/interfaces/generic.interface';

import { AssignmentSummary } from '../info-doc/document-functii-assignment/document-functii-assignment.interface';
import { DocumentTemplateSignaturesComponent } from 'src/app/platform/nomenclatoare/document-template/document-template-signatures/document-template-signatures.component';
import { DocumentTemplateRedactionsComponent } from 'src/app/platform/nomenclatoare/document-template/document-template-redactions/document-template-redactions.component';
import { DocumentGenerabilComponent } from '../info-doc/document-generabil/document-generabil.component';
import { UpdateGenerabilValabilityComponent } from './document-generabil/update-generabil-valability/update-generabil-valability.component';
import { RegistruValabilityComponent } from './registru-valability/registru-valability.component';
import { RegistruValabilityExtendedComponent } from './registru-valability-extended/registru-valability-extended.component';
import { IstoricDocumentGenerabilComponent } from './document-generabil/istoric-document-generabil/istoric-document-generabil.component';
import { DraftValidareComponent } from './draft-validare/draft-validare.component';
import { CetateanUploadComponent } from './cetatean-upload/cetatean-upload.component';
import { UploadAnexeComponent } from './upload-anexe/upload-anexe.component';
import { EditDocumentOficialComponent } from './document-generabil/edit-document-oficial/edit-document-oficial.component';
import { DocumentAssignmentComponent } from './document-assignment/document-assignment.component';
import { DocumentSignatureFlowDialogComponent } from './document-signature-flow-dialog/document-signature-flow-dialog.component';
import { DocumentRedactionFlowDialogComponent } from './document-redaction-flow-dialog/document-redaction-flow-dialog.component';
import { InfoDocumenteSabloaneComponent } from './info-documente-sabloane/info-documente-sabloane.component';
import { SignaturePositionModalComponent, SignatureSelection } from './signature-position-modal/signature-position-modal.component';
import { OperatorSignService, OperatorSignLogData } from 'src/app/services/operator-sign.service';
import { SignServiceStatus } from './operator-sign-status/operator-sign-status.component';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { AddAwbComponent } from './generare-awb/add-awb/add-awb.component';

@Component({
    selector: 'app-info-document',
    templateUrl: './info-document.component.html',
    styleUrls: ['./info-document.component.scss'],
})
export class InfoDocumentComponent implements OnInit {
    appLogoUrl = environment.config.appLogoUrl;
    sourcesApp: any = environment.config.sources;

    currentUser: any = null;
    userAccesses: OperatorAccess[] = [];
    activeAccess: OperatorAccess | null = null;

    userFunctions: UserFunction[] = [];
    activeFunction: UserFunction | null = null;


    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    // Subscription to track our sabloane added from the button below messaging component
    private contentSubscription!: Subscription;

    sendDocumentFilesForm!: FormGroup;
    sendMessageCetateanForm!: FormGroup;
    sendMessageAltaDestinatieForm!: FormGroup;
    sendMessageInternForm!: FormGroup;
    sendMessageNotitaForm!: FormGroup;
    helper = helper;
    token!: string;
    isLoading = false;
    isLoadingInfoDoc = false;
    showEditDocumentFiles = false;

    registruOficialValue: string | null = null;

    private destroy$ = new Subject<void>();

    passedDocId!: number;
    generalData: GeneralData[] = [];

    docData: DocumentData | null = null;
    historyData: DocumentHistory[] = [];
    activityData: DocumentActivity[] = [];
    childrenData: any[] = [];

    adreseRedirect: GenericEmail[] = [];
    filteredAdreseRedirect: GenericEmail[] = [];
    adreseRedirectControl = new FormControl();

    selectedMessagingToggle = 'internalMsg';
    editorConfig!: AngularEditorConfig;

    uploading: any = {
        files_document: false,
        files_mesagerie_cetatean: false,
        files_mesagerie_alta_destinatie: false,
        files_mesagerie_intern: false,
        files_mesagerie_notita: false,
    };

    separatorKeysCodes: number[] = [ENTER, COMMA];
    filteredUsers!: Observable<Colleague[]>;
    users: Colleague[] = [];
    allUsers: Colleague[] = [];
    usersCtrl = new FormControl('');
    @ViewChild('userInput') userInput!: ElementRef<HTMLInputElement>;

    // section for documente generate

    cerere: any = {
        generabile: []
    }

    isDocumentOficialDisabled: boolean = false;


    // zone signatures
    showSignatures: any;
    directii: Generic[] = this.data.directii;
    passedRequestId!: number;

    refreshTrigger: number = 0;

    // Electronic signature status
    signServiceOnline: boolean = false;
    isElectronicSigningInProgress: boolean = false;

    // Global setting for electronic signature feature
    electronicSignatureEnabled: boolean = false;

    /**
     * Getter pentru generabile sortate după id_document (crescător) - din docData
     */
    get sortedGenerabile(): any[] {
        if (!this.docData?.generabile) return [];
        return [...this.docData.generabile].sort((a, b) => a.id_document - b.id_document);
    }

    /**
     * Getter pentru generabile sortate după id_document (crescător) - din cerere
     */
    get sortedCerereGenerabile(): any[] {
        if (!this.cerere?.generabile) return [];
        return [...this.cerere.generabile].sort((a, b) => a.id_document - b.id_document);
    }

    // end section for documente generate

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            docDataListDT: DocumentListDT,
            generalData: GeneralData[],
            directii: Generic[],
            docData: any
        },
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<InfoDocumentComponent>,
        private dialog: MatDialog,
        private dialogService: DialogService,
        public dashboardService: DashboardService,
        private commonService: CommonService,
        private storageService: StorageService,
        private operatoriService: OperatoriService,
        private notificationService: NotificationService,
        private toastService: ToastService,
        private appFilesService: AppFilesService,
        public permissionsService: PermissionsService,
        private breakpointObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        private operatorSignService: OperatorSignService,
        private appSettingsService: AppSettingsService
    ) {
        this.passedDocId = this.data.docDataListDT.id_document;
        this.generalData = this.data.generalData;

        this.registruOficialValue = this.generalData.find(item => item.name === "registru_oficial")?.value ?? null;

        this.loadCurrentUser()
    }

    ngOnInit(): void {
        this.getDocInfo();
        this.loadAdreseRedirectActive();
        this.getUsersListModuleColeagues();
        this.subscribeToSabloaneContent();
        this.renderFieldsSearch();

        this.editorConfig = initializeEditor();
        this.sendDocumentFilesForm = this.fb.group({
            files: this.fb.array([], [Validators.required]),
        });
        this.sendMessageCetateanForm = this.fb.group({
            type: new FormControl('1'),
            message: new FormControl('', [Validators.required]),
            email_sent_to: new FormControl('', []),
            name_sent_to: new FormControl('', []),
            files: this.fb.array([]),
        });
        this.sendMessageAltaDestinatieForm = this.fb.group({
            type: new FormControl('4'),
            message: new FormControl('', [Validators.required]),
            id_sent_to: new FormControl(-1, [Validators.required]),
            email_sent_to: new FormControl('', []),
            name_sent_to: new FormControl('', []),
            files: this.fb.array([]),
        });
        this.sendMessageInternForm = this.fb.group({
            type: new FormControl('2'),
            message: new FormControl('', [Validators.required]),
            coleagues: new FormControl(
                this.users,
                requireMinOneColleagueValidator()
            ),
            files: this.fb.array([]),
        });
        this.sendMessageNotitaForm = this.fb.group({
            type: new FormControl('3'),
            message: new FormControl('', [Validators.required]),
            files: this.fb.array([]),
        });

        // Initialize filtered users for autocomplete
        this.filteredUsers = this.usersCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value ? this._usersFilter(value) : this.allUsers.slice()
            )
        );

        // Subscribe to electronic signature global setting
        this.appSettingsService.getOperatorElectronicSignatureEnabled$()
            .pipe(takeUntil(this.destroy$))
            .subscribe(enabled => {
                this.electronicSignatureEnabled = enabled;
            });
    }

    ngOnDestroy(): void {
        if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    getDocInfo() {
        this.isLoadingInfoDoc = true;

        const document = this.dashboardService
            .findDocument(this.passedDocId)
            .pipe(map((response: any) => response.data));
        const history = this.dashboardService
            .mesagerieHistory(this.passedDocId)
            .pipe(map((response: any) => response.data));
        const activity = this.dashboardService
            .getActivityDoc(this.passedDocId)
            .pipe(map((response: any) => response.data));
        const children = this.dashboardService
            .getChildrenDoc(this.passedDocId)
            .pipe(map((response: any) => response.data));

        combineLatest([document, history, activity, children])
            .pipe(finalize(() => { this.isLoadingInfoDoc = false; }))
            .subscribe({
                next: ([responseDataDoc, responseDataHistory, responseDataActivity, responseDataChildren]) => {
                    this.docData = responseDataDoc;
                    this.historyData = responseDataHistory;
                    this.activityData = responseDataActivity;
                    this.childrenData = responseDataChildren;

                    // Update email in sendMessageCetateanForm if it exists
                    this.sendMessageCetateanForm.get('email_sent_to')?.setValue(this.docData?.entity?.email || '')
                    this.sendMessageCetateanForm.get('name_sent_to')?.setValue(this.docData?.entity?.denumire || '')

                    // CRITICAL: Update cerere with fresh docData to avoid caching issues
                    // This ensures signatures, generabile, and other nested data are refreshed
                    this.cerere = this.docData;

                    this.refreshTrigger++;
                    console.log('trigger:', this.refreshTrigger);

                    if (
                        typeof this.docData?.generabile !== 'undefined' &&
                        this.docData.generabile.length > 0
                    ) {
                        const foundNotSignedFinal = this.docData.generabile.findIndex((item: any) => {
                            return (item.file_signed_final === null || (item.doc_type === 2 && item.file_signed_ex_cetatean === null))
                        });
                        const generabilIndex = foundNotSignedFinal ? foundNotSignedFinal : this.docData.generabile.length - 1;
                        this.showSignatures = this.docData.generabile[generabilIndex].id_document;
                    }
                },
                error: (error) => {
                    let msg;
                    try {
                        msg = error.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon)
                        .then((result) => {
                            this.closeDialog();
                        });
                },
            });
    }

    isSourceOnline(): boolean {
        return !!this.docData?.sourceArr?.some(source => source.slug === 'online');
    }

    openInSourceApp() {
        const appUrl = this.sourcesApp[1]?.appUrl;
        if (!appUrl || !this.docData?.reg_number) {
            return;
        }
        const url = `${appUrl}#/cereri?numarCerere=${encodeURIComponent(this.docData.reg_number)}`;
        window.open(url, '_blank');
    }

    /**
     * Versiune async a getDocInfo - returnează Promise pentru await
     */
    refreshDocInfoAsync(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.isLoadingInfoDoc = true;

            const document = this.dashboardService
                .findDocument(this.passedDocId)
                .pipe(map((response: any) => response.data));
            const history = this.dashboardService
                .mesagerieHistory(this.passedDocId)
                .pipe(map((response: any) => response.data));
            const activity = this.dashboardService
                .getActivityDoc(this.passedDocId)
                .pipe(map((response: any) => response.data));
            const children = this.dashboardService
                .getChildrenDoc(this.passedDocId)
                .pipe(map((response: any) => response.data));

            combineLatest([document, history, activity, children])
                .pipe(finalize(() => { this.isLoadingInfoDoc = false; }))
                .subscribe({
                    next: ([responseDataDoc, responseDataHistory, responseDataActivity, responseDataChildren]) => {
                        this.docData = responseDataDoc;
                        this.historyData = responseDataHistory;
                        this.activityData = responseDataActivity;
                        this.childrenData = responseDataChildren;
                        this.cerere = this.docData;
                        this.refreshTrigger++;
                        resolve();
                    },
                    error: (error) => {
                        reject(error);
                    },
                });
        });
    }

    /**
     * Găsește un document generabil fresh din datele componentei
     */
    getFreshDocumentRow(documentId: number): any | null {
        if (!this.docData?.generabile) return null;
        return this.docData.generabile.find((doc: any) => doc.id_document === documentId) || null;
    }

    renderFieldsSearch() {
        this.adreseRedirectControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredAdreseRedirect = this.adreseRedirect;
                    return of(this.adreseRedirect);
                }
                return this.filterAdreseRedirect(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredAdreseRedirect = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterAdreseRedirect(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.adreseRedirect.filter(email =>
            this.normalizeString(email.email).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    loadAdreseRedirectActive() {
        this.isLoading = true;
        this.commonService
            .getAdreseRedirectActive()
            .pipe(
                takeUntil(this.destroy$),
                map((results: GenericEmail[]) => results.map(item => item)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (res) => {
                    this.adreseRedirect = res;
                    this.filteredAdreseRedirect = [...this.adreseRedirect];
                },
                error: (error) => {
                    console.error('Error loading adrese redirect', error);
                },
            });
    }

    onAdreseRedirectClosed() {
        const selectedValue = this.adreseRedirectControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredAdreseRedirect.some(email =>
                email.id === this.sendMessageAltaDestinatieForm.get('id_sent_to')?.value
            );

            if (!isSelectedInFilteredList) {
                this.adreseRedirectControl.setValue(null);
                this.filteredAdreseRedirect = this.adreseRedirect;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onAdreseRedirectChange(id: number) {
        const selectedEmail = this.adreseRedirect.find(email => email.id === id);

        if (selectedEmail) {
            this.sendMessageAltaDestinatieForm.get('email_sent_to')?.patchValue(selectedEmail.email);
            this.sendMessageAltaDestinatieForm.get('name_sent_to')?.patchValue(selectedEmail.name);
        }
    }

    getUsersListModuleColeagues(): void {
        this.isLoading = true;
        this.commonService.getUsersListModuleColeagues()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (result) => {
                    this.allUsers = result;
                },
                error: (error) => {
                    console.error('Error in get users coleagues:', error);
                }
            })
    }

    private loadCurrentUser(): void {
        this.storageService.getObject(environment.config.userKey)
            .then((user) => {
                this.currentUser = user;
                this.loadUserAccesses();
                this.loadUserFunctions();
            })
            .catch((error) => {
                console.error('Error loading current user:', error);
            });
    }

    private loadUserFunctions(): void {
        if (!this.currentUser?.id_user) {
            return;
        }

        this.isLoading = true;

        this.operatoriService.getUserMultipleFunctii(this.currentUser.id_user)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response: any) => {
                    this.userFunctions = response.data?.functions || [];
                    this.activeFunction = this.userFunctions.find(func => func.is_active) || null;
                },
                error: (error) => {
                    console.error('Error loading user functions:', error);

                    // Don't show error for new users (404 expected)
                    if (error.status !== 404) {
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            'Eroare la încărcarea funcțiilor utilizatorului',
                            this.errorIcon
                        );
                    }
                }
            });
    }

    private loadUserAccesses(): void {
        if (!this.currentUser?.id_user) {
            return;
        }

        this.isLoading = true;

        this.operatoriService.getOperatorAccess()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response) => {
                    this.userAccesses = response.data || [];
                    this.activeAccess = this.userAccesses.find(access => access.active) || null;
                },
                error: (error) => {
                    console.error('Error loading user accesses:', error);

                    // Don't show error for new users (404 expected)
                    if (error.status !== 404) {
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            'Eroare la încărcarea acceselor utilizatorului',
                            this.errorIcon
                        );
                    }
                }
            });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    private _usersFilter(value: string | Colleague): Colleague[] {
        let filterValue = '';
        if (typeof value === 'string') {
            filterValue = value.toLowerCase();
        } else {
            filterValue = value.name.toLowerCase();
        }

        return this.allUsers.filter((user) =>
            user.name.toLowerCase().includes(filterValue)
        );
    }

    addUser(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        if (value) {
            const foundOption = this.allUsers.find(
                (user) => this.normalizeString(user.name) === this.normalizeString(value)
            );
            if (foundOption) {
                this.users.push(foundOption);
                this.sendMessageInternForm.controls['coleagues'].setValue([
                    ...this.users,
                ]);
                this.sendMessageInternForm.controls[
                    'coleagues'
                ].updateValueAndValidity();
            }
        }

        event.chipInput!.clear();
        this.usersCtrl.setValue(null);
    }

    removeUser(user: Colleague): void {
        const index = this.users.indexOf(user);

        if (index >= 0) {
            this.users.splice(index, 1);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls['coleagues'].setValue([
                ...this.users,
            ]);
            this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
        }
    }

    selectedUsers(event: MatAutocompleteSelectedEvent): void {
        const selectedOption = this.allUsers.find(
            (user) => user.name === event.option.viewValue
        );
        if (
            selectedOption &&
            !this.users.find(
                (user) => user.id_user === selectedOption.id_user
            )
        ) {
            this.users.push(selectedOption);
            this.userInput.nativeElement.value = '';
            this.usersCtrl.setValue(null);
            // Update the form control to reflect changes and re-validate
            this.sendMessageInternForm.controls['coleagues'].setValue([
                ...this.users,
            ]);
            this.sendMessageInternForm.controls['coleagues'].updateValueAndValidity();
        }
    }

    addFile(event: any, key: string) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        let formGroup: FormGroup<any> = new FormGroup('');
        switch (key) {
            case 'files_document':
                formGroup = this.sendDocumentFilesForm;
                break;

            case 'files_mesagerie_cetatean':
                formGroup = this.sendMessageCetateanForm;
                break;

            case 'files_mesagerie_alta_destinatie':
                formGroup = this.sendMessageAltaDestinatieForm;
                break;

            case 'files_mesagerie_intern':
                formGroup = this.sendMessageInternForm;
                break;

            case 'files_mesagerie_notita':
                formGroup = this.sendMessageNotitaForm;
                break;
        }

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = formGroup.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileUpload) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.toastService.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading[key] = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.dashboardService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = formGroup.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;

                            this.toastService.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        // Handle error cases here
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    removeFile(index: number, key: string) {
        let formGroup: FormGroup<any> | null = null;
        switch (key) {
            case 'files_document':
                formGroup = this.sendDocumentFilesForm;
                break;

            case 'files_mesagerie_cetatean':
                formGroup = this.sendMessageCetateanForm;
                break;

            case 'files_mesagerie_alta_destinatie':
                formGroup = this.sendMessageAltaDestinatieForm;
                break;

            case 'files_mesagerie_intern':
                formGroup = this.sendMessageInternForm;
                break;

            case 'files_mesagerie_notita':
                formGroup = this.sendMessageNotitaForm;
                break;
        }
        if (formGroup) {
            const files = formGroup.get('files') as FormArray;
            if (index > -1 && index < files.length) {
                files.removeAt(index);
            }
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.toastService.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    toggleEditDocumentFiles() {
        this.showEditDocumentFiles = !this.showEditDocumentFiles;
    }

    closeEditDocumentFiles() {
        this.showEditDocumentFiles = false;
    }

    downloadTempFile(uploadedFile: FileUpload) {
        this.isLoading = true;
        const fullPath = this.dashboardService.tempFileDownloadUrl;

        const payload = {
            fileName: uploadedFile.filename,
            originalName: uploadedFile.original_name,
        }
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentFile(file: FileDocument) {
        this.isLoading = true;
        const fullPath = this.dashboardService.documentDownloadFileUrl + file.id;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    deleteDocumentFile(id_file: number) {
        this.isLoading = true;

        this.dashboardService.documentDeleteFile(this.passedDocId, id_file)
            .pipe(
                finalize(() => { this.isLoading = false; })
            )
            .subscribe({
                next: (res) => {
                    this.getDocInfo();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    submitDocumentFiles() {
        this.isLoading = true;

        const payload = this.sendDocumentFilesForm.value;

        this.dashboardService.documentUploadFile(this.passedDocId, payload)
            .pipe(
                finalize(() => { this.isLoading = false; })
            )
            .subscribe({
                next: (res) => {
                    this.getDocInfo();

                    const filesFormArray = this.sendDocumentFilesForm.get(
                        'files'
                    ) as FormArray;
                    filesFormArray.clear();
                    this.sendDocumentFilesForm.clearValidators();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onMessagingChange(event: MatButtonToggleChange) {
        this.selectedMessagingToggle = event.value;
    }

    submitMessage(section: any) {
        this.isLoading = true;

        let newMessage;
        switch (section) {
            case 'cetatean':
                newMessage = this.sendMessageCetateanForm.value;
                break;

            case 'alta-destinatie':
                newMessage = this.sendMessageAltaDestinatieForm.value;
                break;

            case 'intern':
                newMessage = this.sendMessageInternForm.value;
                break;

            case 'nota':
                newMessage = this.sendMessageNotitaForm.value;
                break;
        }

        this.dashboardService
            .postMessage(this.passedDocId, newMessage)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                    // this.uploadedFileNames = [];
                    // this.resetAllForms();
                })
            )
            .subscribe({
                next: (res) => {
                    this.isLoading = true;
                    // Commented the function below so that we dont have a popup when the loading spinner is active
                    // this.notificationService.warningSwal(
                    //   this.successTitle,
                    //   'Document actualizat cu succes!',
                    //   this.successIcon
                    // );
                    // Reset forms and refresh data
                    this.resetAllForms();
                    this.getDocInfo();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    resetAllForms() {
        if (this.sendMessageCetateanForm.value) {
            this.sendMessageCetateanForm.get('type')?.setValue('1');
            this.sendMessageCetateanForm.get('message')?.setValue('');
            this.sendMessageCetateanForm.get('message')?.setErrors(null);
            this.sendMessageCetateanForm.get('message')?.markAsUntouched();
            this.sendMessageCetateanForm.get('email_sent_to')?.setValue(this.docData?.entity?.email || '');
            this.sendMessageCetateanForm.get('name_sent_to')?.setValue(this.docData?.entity?.denumire || '');

            const filesFormArray = this.sendMessageCetateanForm.get(
                'files'
            ) as FormArray;
            filesFormArray.clear();
            this.sendMessageCetateanForm.clearValidators();
        }

        if (this.sendMessageAltaDestinatieForm.value) {
            this.sendMessageAltaDestinatieForm.get('type')?.setValue('4');
            this.sendMessageAltaDestinatieForm.get('message')?.setValue('');
            this.sendMessageAltaDestinatieForm.get('message')?.setErrors(null);
            this.sendMessageAltaDestinatieForm.get('message')?.markAsUntouched();
            this.sendMessageAltaDestinatieForm.get('id_sent_to')?.setValue(-1);
            this.sendMessageAltaDestinatieForm.get('id_sent_to')?.setErrors(null);
            this.sendMessageAltaDestinatieForm.get('id_sent_to')?.markAsUntouched();
            this.sendMessageAltaDestinatieForm.get('email_sent_to')?.setValue('');
            this.sendMessageAltaDestinatieForm.get('name_sent_to')?.setValue('');

            const filesFormArray = this.sendMessageAltaDestinatieForm.get('files') as FormArray;
            filesFormArray.clear();
            this.sendMessageAltaDestinatieForm.clearValidators();
        }

        if (this.sendMessageInternForm.value) {
            this.sendMessageInternForm.get('type')?.setValue('2');
            this.sendMessageInternForm.get('message')?.setValue('');
            this.sendMessageInternForm.get('message')?.setErrors(null);
            this.sendMessageInternForm.get('message')?.markAsUntouched();
            this.users = []; // Reset users

            const filesFormArray = this.sendMessageInternForm.get('files') as FormArray;
            filesFormArray.clear();
            this.sendMessageInternForm.clearValidators();
        }

        if (this.sendMessageNotitaForm.value) {
            this.sendMessageNotitaForm.get('type')?.setValue('3');
            this.sendMessageNotitaForm.get('message')?.setValue('');
            this.sendMessageNotitaForm.get('message')?.setErrors(null);
            this.sendMessageNotitaForm.get('message')?.markAsUntouched();

            const filesFormArray = this.sendMessageNotitaForm.get('files') as FormArray;
            filesFormArray.clear();
            this.sendMessageNotitaForm.clearValidators();
        }
    }

    subscribeToSabloaneContent() {
        this.contentSubscription = this.dashboardService.sablonContent$.subscribe({
            next: (data) => {
                switch (data.section) {
                    case 'cetatean':
                        this.sendMessageCetateanForm.controls['message'].setValue(data.content);
                        break;

                    case 'alta-destinatie':
                        this.sendMessageAltaDestinatieForm.controls['message'].setValue(data.content);
                        break;
                }
            },
        });
    }

    openSabloane(section: string) {
        const dialogRef = this.dialog.open(InfoDocumenteSabloaneComponent, {
            minHeight: '60vh',
            maxHeight: '90vh',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
            data: {
                section: section
            }
        });

        dialogRef
            .afterClosed()
            .subscribe(({ success }: { success: boolean }) => { });
    }

    openInchidereDocument(data: DocumentData) {
        let dialogRef = this.dialog.open(ModalInchidereLucrareComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
        });
    }

    resetInchidereDocument() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea închiderii de lucrare?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea un motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.dashboardService
                    .resetInchidereDocument(this.passedDocId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    handleButtonClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'închidere lucrare':
                this.openInchidereDocument(this.docData!);
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    handleButtonResetClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'închidere lucrare':
                this.resetInchidereDocument();
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }

    openAddDialogIntrare(serieId: number, reg_number: number | null) {
        const dialogRef = this.dialog.open(DocIntrareComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                reg_number: reg_number,
                serieId: serieId,
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse }) => {
            if (success) {
                this.getDocInfo();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openAddDialogIntern(serieId: number, reg_number: number | null) {
        const dialogRef = this.dialog.open(DocumentInternComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                reg_number: reg_number,
                serieId: serieId
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse }) => {
            if (success) {
                this.getDocInfo();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    // typeDoc info
    // 1 => new number for document, indiferent de natura lui
    // 2 => transfer document catre o alta entitate.. dar preia acelasi numar!!! (DGITL)
    // 3 => restituire, catre emitent cu un raspuns. Asta inseamna ca avem anumite formalitati noi!!! (DGITL)
    openAddDialogIesire(typeDoc: number = 1, serieId: number, reg_number: number | null) {
        const dialogRef = this.dialog.open(DocumentIesireComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
                reg_number: reg_number,
                serieId: serieId,
                typeDoc: typeDoc
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse }) => {
            if (success) {
                this.getDocInfo();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openEditInfo() {
        const dialogRef = this.dialog.open(EditInfoComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                docData: this.docData,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
                this.toastService.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Info documentație actualizată cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    compareNumbers(number1: number | null, number2: number | null) {
        return (number1 === number2 ? true : false);
    }

    checkPermissionFromView(slug: string) {
        return this.permissionsService.hasPermission(slug);
    }

    // documente generabile section

    // DocumentGenerabil
    getDocumentAssignmentCssClass(document: any): string {
        if (!document.has_assignment) {
            return 'badge-light';
        }

        if (document.assigned_user_name) {
            return 'badge-success';
        }

        if (document.assigned_functie_name) {
            return 'badge-warning';
        }

        return 'badge-secondary';
    }

    /**
     * Get assignment status display for a document
     */
    // DocumentGenerabil
    getDocumentAssignmentStatus(document: any): string {
        if (!document.has_assignment) {
            return 'Neasignat';
        }

        if (document.assigned_user_name) {
            return `Asignat: ${document.assigned_user_name}`;
        }

        if (document.assigned_functie_name) {
            return `Funcție: ${document.assigned_functie_name}`;
        }

        return 'Asignare parțială';
    }

    // ==================== Document Assignment Methods ==================== //

    /**
     * Open document assignment dialog
     */
    // DocumentGenerabil
    openDocumentAssignment(document: any): void {
        const dialogRef = this.dialog.open(DocumentAssignmentComponent, {
            width: '700px',
            maxWidth: '90vw',
            disableClose: true,
            data: {
                document: document,
                cerereId: this.cerere!.id_cerere,
                directii: this.directii
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.success) {
                // Refresh the cerere data to show updated assignments
                this.getDocInfo();

                if (result.unassigned) {
                    this.notificationService.successSwal(
                        'Succes',
                        'Asignarea documentului a fost eliminată cu succes'
                    );
                } else {
                    this.notificationService.successSwal(
                        'Succes',
                        'Documentul a fost asignat cu succes'
                    );
                }
            }
        });
    }

    // DocumentGenerabil
    updateDocumentGenerat(row: any) {
        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: row
        };

        const dialogRef = this.dialog.open(EditDocumentOficialComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    // This function checks if all signatures are not null inside a signature array of objects for a any doc generabil
    allFilesSigned(signatures: any): boolean {
        return signatures.every((signature: any) => signature.file_signed !== null);
    }
    // mesaj catre cetatean nu mai apare ceasul - de vazut de ce

    downloadDocumentGeneratBE(id: number, doc_type: number) {
        // + '/' + doc_type;
        let fullPath =
            this.dashboardService.downloadDocumentGeneratUrl + id + '/' + doc_type;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    // DocumentGenerabil
    downloadDocumentGenerat(row: any, doc_type: number) {
        if (row.file_signed_final !== null) {
            this.downloadDocumentOfficial(row.id_document, doc_type);
        } else if (row.file_signed !== null) {
            this.downloadDocumentSigned(row.id_document, doc_type);
        } else {
            this.downloadDocumentGeneratBE(row.id_document, doc_type);
        }
    }

    downloadDocumentOfficial(id: number, doc_type: number = 1) {
        // let fullPath = this.da.downloadDocumentSignedUrl + id; // wrong ?

        let fullPath = this.dashboardService.downloadDocumentOfficialUrl + id + '?doc_type=' + doc_type;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentSigned(id: number, doc_type: number = 1) {
        let fullPath = this.dashboardService.downloadDocumentSignedUrl + id + '?doc_type=' + doc_type;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    downloadDocumentTableSignatures(id: number) {
        let fullPath = this.dashboardService.downloadTableSignaturesURL + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    validateDocument(documentGeneratId: number, type: number, doc_type: number = 0, canApplySeal: boolean = false) {
        const dialogRef = this.dialog.open(DraftValidareComponent, {
            minHeight: 'auto',
            maxHeight: 'auto',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
            data: {
                id: documentGeneratId,
                type,
                doc_type,
                canApplySeal
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
        });
    }

    // ICerere
    viewIstoricDocument(row: any) {
        const dialogRef = this.dialog.open(IstoricDocumentGenerabilComponent, {
            minHeight: '50vh',
            maxHeight: '50vh',
            minWidth: '60vw',
            maxWidth: '60vw',
            disableClose: true,
            data: row.istoric,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
        });
    }

    destroyDocumentGenerat(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.deleteDocument,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.dashboardService
                    .destroyDocument(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                this.isDocumentOficialDisabled = false;
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    resetDocumentIntocmitor(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.confirmReset,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.dashboardService
                    .resetDocumentIntocmitorValidated(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    // this.isDocumentOficialDisabled = true; // i don't understand this rule.. i need explination please :)
                    this.getDocInfo();
                });
            }
        });
    }

    openRegistruValability(data: any) {
        // Always open extended component with seal functionality
        const dialogRef = this.dialog.open(RegistruValabilityExtendedComponent, {
            minWidth: '60vw',
            maxWidth: '70vw',
            disableClose: true,
            data: {
                id_document: data.id_document,
                passedRequestId: this.passedRequestId,
                valability: data.valability,
                canApplySeal: this.allFilesSigned(data.signatures),
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result?.success) {
                this.getDocInfo();
            }
        });
    }

    resetUploadDocumentOfficial(id_document: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați documentul. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.dashboardService
                    .resetUploadDocumentOfficial(id_document)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Document resetat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getDocInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    sendDocumentForwardIntocmitor(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O sa trimiteți documentul mai departe pe flux confirmând documentul încărcat ca fiind cel corect',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Completați motivul...',
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.dashboardService
                    .sendDocumentForwardIntocmitor(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Operațiune rulată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    rsyncSignaturesDocumentGenerat(documentId: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați semnatarii. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.dashboardService
                    .rsyncSignaturesDocumentGenerat(documentId)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Semnatari resetați cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getDocInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    openAddAWBDialog(): void {
        const dialogRef = this.dialog.open(AddAwbComponent, {
            width: '1000px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                generalData: this.generalData,
                docData: this.docData,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.getDocInfo();
            }
        });
    }

    notificareCetateanDocumentOficial(documentId: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Doriți să trimiteți/notificați cetățeanul privind documentul/documentele oficiale încărcate?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.dashboardService
                    .sendNotificationCetateanDocumentOficial(documentId)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Notificare trimisă cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    resetDocumentOficialNotificareCetatean(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să resetați documentul. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.dashboardService
                    .resetDocumentOficialNotificareCetatean(id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Document resetat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getDocInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    // actualizare document generat - setare tip document
    setDocTypeForDocument(idDocGenerat: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: "O sa actualizati tipul documentului Generat/In lucru",
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return this.dashboardService
                    .setDocTypeForDocument(idDocGenerat)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    editDateDocGenerabil(id_document: number) {
        const dialogRef = this.dialog.open(UpdateGenerabilValabilityComponent, {
            minWidth: '40vw',
            maxWidth: '40vw',
            data: id_document,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
        });
    }

    downloadAnexa(file: any) {
        let fullPath = this.dashboardService.downloadDocumentAnexaUrl + file.id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    /**
     * Deschide modalul pentru upload anexe
     */
    openUploadAnexeModal(row: any): void {
        const dialogRef = this.dialog.open(UploadAnexeComponent, {
            minHeight: 'auto',
            maxHeight: '80vh',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
            data: {
                documentGeneratId: row.id_document,
                existingAnexe: row.documenteOficialeAnexe?.filter((a: any) => a.active === 1 || a.active === true) || [],
                canDelete: row.confirmat == null
            }
        });

        dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
            if (result?.success) {
                this.getDocInfo();
            }
        });
    }

    /**
     * Deschide dialogul pentru vizualizarea fluxului de semnături
     */
    openSignatureFlowDialog(row: any): void {
        this.dialog.open(DocumentSignatureFlowDialogComponent, {
            width: '95vw',
            maxWidth: '1200px',
            height: '90vh',
            panelClass: 'signature-flow-dialog-panel',
            data: {
                documentGeneratId: row.id_document,
                templateName: row.document_template?.name || row.template_name
            }
        });
    }

    /**
     * Deschide dialogul pentru vizualizarea circuitului de redactare
     */
    openRedactionFlowDialog(row: any): void {
        const dialogRef = this.dialog.open(DocumentRedactionFlowDialogComponent, {
            width: '95vw',
            maxWidth: '700px',
            height: '90vh',
            panelClass: 'redaction-flow-dialog-panel',
            data: {
                documentGeneratId: row.id_document,
                templateName: row.document_template?.name || row.template_name,
                canEdit: this.canEditDocument(row),
                // User context for permission checks
                currentUserId: this.currentUser?.id_user,
                activeFunctieId: this.activeFunction?.functie_id,
                activeDirectieId: this.activeAccess?.id_directie,
                activeCompartimentId: this.activeAccess?.id_compartiment
            }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.refreshDocument) {
                this.getDocInfo();
            }
        });
    }

    /**
     * Inițializează circuitul de redactare pentru un document generat
     * Apelează endpoint-ul de inițializare din template
     */
    initializeRedactionCircuit(row: any): void {
        this.dashboardService.initializeRedactionFromTemplate(row.id_document).subscribe({
            next: (response) => {
                if (response.success) {
                    this.notificationService.successSwal('Succes', 'Circuit redactare inițializat cu succes');
                    this.getDocInfo(); // Refresh pentru a vedea noul status
                } else {
                    this.notificationService.warningSwal('Eroare', response.message || 'Eroare la inițializare circuit redactare', 'error');
                }
            },
            error: (error) => {
                this.notificationService.warningSwal('Eroare', error.error?.message || error.error?.error || 'Eroare la inițializare circuit redactare', 'error');
            }
        });
    }

    /**
     * Confirmare ștergere anexă cu Swal
     */
    confirmDeleteAnexa(anexa: any, row: any): void {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: `Sigur doriți să ștergeți anexa "${anexa.old_name}"?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
            preConfirm: () => {
                return this.dashboardService
                    .deleteDocumentGeneratAnexa(anexa.id)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = err?.error?.error || err?.error?.message || helper.dialogConfig.generalMessages.error;
                        Swal.showValidationMessage(`${msg}`);
                    });
            }
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Anexa a fost ștearsă cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    generateDocAdresa() {
        const is_address = true;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                document: this.cerere,
                type: 2, // adrese
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }

    generateDocOfficial() {
        const is_address = false;

        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
            disableClose: true,
            panelClass: 'scroll-modalbox',
            data: {
                document: this.cerere,
                type: 1, // doc official
                is_address: is_address,
            }
        };

        const dialogRef = this.dialog.open(DocumentGenerabilComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 699px)', // xs breakpoint
            '(min-width: 700px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 699px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('60%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getDocInfo();
            }
            layoutChangeSubscription.unsubscribe();
        });
    }


    // zone signatures
    showEditSemnatari: boolean = false;
    selectedSignature: number = -1
    selectSemnatariList: any = [];
    destination_signatures_document: string = 'toPrimarie';

    // Redactare - actualizare redactor curent
    showEditRedactari: boolean = false;
    selectedRedactor: number = -1;
    documentTypesTranslation: any = {
        'toPrimarie': 1,
        'toCetatean': 2
    }
    documentTypesTranslationReverse: any = {
        1: 'toPrimarie',
        2: 'toCetatean'
    }


    filteredColeagues!: any;
    // Coleg
    coleagues: any[] = []; // Coleg
    allColeagues: any[] = []; // Coleg
    coleaguesCtrl = new FormControl('');

    useActiveFunction: boolean = false;
    selectedSpecificUser: any = null;
    showSpecificUserSelection: boolean = false;
    availableUsersForFunction: any[] = [];
    allowDelegation: boolean = false;
    canAllowDelegation: boolean = false;

    switchViewSignatures(doc: any) {
        this.showSignatures = doc.id_document;
        this.showEditSemnatari = false;

        // get document info
        this.destination_signatures_document = this.documentTypesTranslationReverse[doc.doc_type_active]
    }

    onDestinatieChange(event: any, doc: any = null) {
        console.log(event, 'event?')
        if (doc !== null) {
            this.getSignatureList(doc)
        }
    }

    getSignatureList(doc: any = null) {
        if (doc !== null && this.showEditSemnatari == true) {
            this.selectSemnatariList = []; // Resetează lista
            this.selectedSignature = doc.validare_user_type;

            console.log('doc.validare_user_type:', doc.validare_user_type);

            // let extraOption = {
            //     user_type: 0,
            //     user_type_name: "Intocmitor"
            // }
            // this.selectSemnatariList.push(extraOption);

            let indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document];
            doc.signatures_doc[indexSignatureTypes].forEach((item: any) => {
                let obj = {
                    user_type: item.user_type,
                    user_type_name: item.user_type_name
                }
                this.selectSemnatariList.push(obj);
            });

            console.log('After getSignatureList - selectedSignature:', this.selectedSignature);
        }
    }

    editSemnatari(event: any, doc: any = null): void {
        this.showEditSemnatari = !this.showEditSemnatari;

        if (doc !== null && this.showEditSemnatari == true) {
            // Resetează valorile
            this.selectedSpecificUser = null;
            this.useActiveFunction = false;
            this.allowDelegation = false;
            this.showSpecificUserSelection = false;
            this.availableUsersForFunction = [];

            // Setăm destination_signatures_document corect bazat pe doc_type_active
            if (doc.doc_type_active) {
                this.destination_signatures_document = this.documentTypesTranslationReverse[doc.doc_type_active] || 'toPrimarie';
            }

            this.getSignatureList(doc);

            // Găsește signature-ul curent activ și setează valorile preselectate
            if (this.selectedSignature && this.selectedSignature !== -1) {
                this.findCurrentSignatureAndPreselect(doc);
            }
        }
    }

    findCurrentSignatureAndPreselect(doc: any) {
        const indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document];
        const currentSignature = doc.signatures_doc[indexSignatureTypes]?.find((sig: any) =>
            sig.user_type === this.selectedSignature
        );

        console.log('current SIGNATURE: ', currentSignature);

        if (currentSignature) {
            // Setează checkbox-ul pentru funcția activă
            this.useActiveFunction = currentSignature.use_active_function || false;

            // Verifică dacă permite selecția specifică (bazat pe template sau alte criterii)
            this.checkIfSpecificUserAllowed(this.selectedSignature);

            // Încarcă utilizatorii pentru această funcție
            this.loadUsersForFunction(this.selectedSignature);

            // Dacă există un utilizator specific asignat, preselectează-l
            if (currentSignature.specific_user_id && currentSignature.specific_user_name) {
                // Așteaptă să se încarce utilizatorii, apoi preselectează
                setTimeout(() => {
                    const preselectedUser = this.availableUsersForFunction.find(user =>
                        user.id === currentSignature.specific_user_id
                    );
                    if (preselectedUser) {
                        this.selectedSpecificUser = preselectedUser;
                        console.log('PRESELECTEDUSER: ', preselectedUser)
                    }
                }, 1000);
            }

            console.log('Current signature found:', currentSignature);
            console.log('useActiveFunction set to:', this.useActiveFunction);
        }
    }

    checkIfSpecificUserAllowed(functionId: number) {
        console.log('checkIfSpecificUserAllowed called with:', functionId);

        // Verifică configurația template-ului sau alte criterii pentru a determina
        // dacă se permite selecția persoanei specifice
        const cerereData = this.cerere as any;
        const currentDoc = cerereData?.generabile?.find((doc: any) => doc.id_document === this.showSignatures);

        if (currentDoc && currentDoc.signatures_doc) {
            const indexSignatureTypes: any = this.documentTypesTranslation[this.destination_signatures_document];
            const templateSig = currentDoc.signatures_doc[indexSignatureTypes]?.find((sig: any) =>
                sig.user_type === functionId
            );

            if (templateSig) {
                // Bazează decizia pe existența unui utilizator specific sau alte criterii
                this.showSpecificUserSelection = true; // Sau bazează pe templateSig.allow_specific_user
                this.canAllowDelegation = templateSig.allow_delegation || false;
            } else {
                this.showSpecificUserSelection = true; // Default la true pentru flexibilitate
                this.canAllowDelegation = false;
            }
        } else {
            // Default behavior
            this.showSpecificUserSelection = true;
            this.canAllowDelegation = false;
        }

        console.log('showSpecificUserSelection set to:', this.showSpecificUserSelection);
        console.log('canAllowDelegation:', this.canAllowDelegation);
    }

    loadUsersForFunction(functionId: number) {
        // Get users with this function from the operator service
        // Pass the only_active parameter to the backend
        this.operatoriService.getUsersByFunctie(functionId, this.useActiveFunction).subscribe({
            next: (response: any) => {
                if (response && response.data) {
                    // Handle both array and nested object responses
                    const userData = Array.isArray(response.data) ? response.data : (response.data.data || []);

                    if (Array.isArray(userData)) {
                        this.availableUsersForFunction = userData.map((user: any) => ({
                            id: user.id_user || user.id,
                            name: user.name || 'Unknown User',
                            email: user.email || '',
                            is_active: user.is_active_function || false,
                            user_functie_id: user.user_functie_id || user.id
                        }));

                        // No need to filter here since backend already filters if useActiveFunction is true
                        console.log(`Loaded ${this.availableUsersForFunction.length} users for function ${functionId} (active only: ${this.useActiveFunction})`);
                        console.log(this.availableUsersForFunction);
                    } else {
                        console.warn('Unexpected data format from getUsersByFunctie:', response);
                        this.availableUsersForFunction = [];
                    }
                } else {
                    this.availableUsersForFunction = [];
                }
            },
            error: (error) => {
                console.error('Error loading users for function:', error);
                this.availableUsersForFunction = [];
                // Show user-friendly error notification
                this.notificationService.warningSwal(
                    'Eroare',
                    'Nu s-au putut încărca utilizatorii pentru această funcție',
                    'error'
                );
            }
        });
    }

    addSemnatari(doc: any) {
        console.log(doc.id_document);
        let isCerereDetalii = true;
        let data = {
            manual_override: true,
            // id_document: this.docData?.id_document, // id_document generat
            id: doc.id_document, // template ID
            document_generabil_dual: doc.doc_type, // document_generabil_dual - doc_type - exemplar
            doc_type: this.documentTypesTranslation[this.destination_signatures_document], // document_generabil_dual - doc_type - exemplar
            name: doc.template // denumire template
        };
        const dialogRef = this.dialog.open(DocumentTemplateSignaturesComponent, {
            height: '70vh',
            maxHeight: '70vh',
            width: '75vh',
            maxWidth: '75vh',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.isLoading = true;
                this.rsyncSignaturesDocumentGenerat(doc.id_document);
            }
        });
    }

    /**
     * Deschide dialogul pentru configurarea circuitului de redactare pe document generat
     * Similar cu addSemnatari, dar pentru redactări
     */
    addRedactari(doc: any) {
        console.log('addRedactari', doc.id_document);
        let data = {
            manual_override: true,
            id: doc.id_document, // document generat ID
            name: doc.template, // denumire template
            isCerereDetalii: true
        };
        const dialogRef = this.dialog.open(DocumentTemplateRedactionsComponent, {
            height: '70vh',
            maxHeight: '70vh',
            width: '75vh',
            maxWidth: '75vh',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }) => {
            if (success) {
                this.isLoading = true;
                this.getDocInfo(); // Reîncarcă informațiile documentului
            }
        });
    }

    downloadDocumentFromSignatureSigned(id: number) {
        let fullPath = this.dashboardService.downloadDocumentSignatureSignedUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    resetDocument(documentId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.headers.error,
            text: this.helper.swalTextConfig.generalMessages.confirmReset,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder:
                this.helper.swalTextConfig.inputPlaceholders.deleteDocument,
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.dashboardService
                    .resetDocumentValidated(documentId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages
                        .deleteDocumentSuccess,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    sendDocumentForwardToSigner(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să trimiteți documentul mai departe pe flux confirmând documentul încărcat ca fiind cel corect',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Completați motivul...',
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.dashboardService
                    .sendDocumentForwardToSigner(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Operațiune rulată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    sendDocumentToIntocmitor(signatureId: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să trimiteți documentul înapoi pe flux la Întocmitor',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Completați motivul...',
            reverseButtons: true,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.dashboardService
                    .sendDocumentToIntocmitor(signatureId, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Operațiune rulată cu succes.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();
                });
            }
        });
    }

    onSignatureSelect() {
        console.log('onSignatureSelect called with:', this.selectedSignature);

        // Resetează valorile când se schimbă selecția
        this.selectedSpecificUser = null;
        this.useActiveFunction = false;
        this.allowDelegation = false;

        if (this.selectedSignature && this.selectedSignature !== -1) {
            this.checkIfSpecificUserAllowed(this.selectedSignature);
            this.loadUsersForFunction(this.selectedSignature);
        } else {
            this.availableUsersForFunction = [];
            this.showSpecificUserSelection = false;
        }

        console.log('After onSignatureSelect - showSpecificUserSelection:', this.showSpecificUserSelection);
    }

    onActiveFunctionToggle() {
        // Reload users when the active function checkbox is toggled
        if (this.selectedSignature && this.selectedSignature !== -1) {
            console.log('Active function toggle changed to:', this.useActiveFunction);
            this.loadUsersForFunction(this.selectedSignature);
        }
    }

    editSemnatariSubmit(idDocGenerat: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'O să modificați semnatarul curent. Continuați?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: () => {
                let data: any = {
                    destination_signatures_document: this.destination_signatures_document,
                    selectedSignature: this.selectedSignature,
                    useActiveFunction: this.useActiveFunction
                }

                // Add specific user assignment if selected
                if (this.selectedSpecificUser) {
                    data.specificUserId = this.selectedSpecificUser.id;
                    data.userFunctieId = this.selectedSpecificUser.user_functie_id;
                    data.specificAssignments = [{
                        user_type: this.selectedSignature,
                        user_id: this.selectedSpecificUser.id,
                        user_functie_id: this.selectedSpecificUser.user_functie_id,
                        user_name: this.selectedSpecificUser.name
                    }];
                }

                // Add delegation flag if allowed
                if (this.allowDelegation && this.canAllowDelegation) {
                    data.allowDelegation = true;
                }

                return this.dashboardService
                    .updateCurrentSignatureDocument(idDocGenerat, data)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getDocInfo();

                    // Force Angular to detect changes immediately
                    this.cdr.detectChanges();
                });
            }
        });
    }

    onAssignmentsUpdated(assignmentSummary: AssignmentSummary) {
        // Handle assignment updates if needed
        // This could trigger UI updates or notifications
        console.log('Assignments updated:', assignmentSummary);

        // Refresh the entire document data to ensure everything is in sync
        this.getDocInfo();

        // Force Angular to detect changes immediately
        this.cdr.detectChanges();
    }

    // end documente generabile section

    toggleDetailsSignature(signatureId: number, index: any) {
        this.docData?.generabile.forEach((doc: any) => {
            if (doc.id_document === this.showSignatures) {
                doc.signatures_doc[index].forEach((signature: any) => {
                    if (signature.id === signatureId) {
                        signature.view_details = !signature.view_details;
                    }
                });
            }
        });
    }

    // ==================== Electronic Signature Methods ==================== //

    /**
     * Handler pentru schimbarea statusului serviciului de semnare
     */
    onSignServiceStatusChange(status: SignServiceStatus): void {
        this.signServiceOnline = status === 'online';
        this.cdr.detectChanges();
    }

    /**
     * Zona b.1 - Semnare electronică în flux (semnatari secvențiali)
     */
    async openElectronicSignature(doc: any, signature: any): Promise<void> {
        if (this.isElectronicSigningInProgress) {
            this.toastService.openToast({ type: 'warning', message: 'Așteptați finalizarea operațiunii curente de semnare.', title: 'Atenție' });
            return;
        }

        this.isElectronicSigningInProgress = true;

        try {
            // 1. Pregătește datele pentru log
            const logData: OperatorSignLogData = {
                user_id: this.currentUser?.id_user,
                user_name: this.currentUser?.name || '',
                directie_id: this.activeAccess?.id_directie,
                directie_name: this.activeAccess?.denumire_directie,
                compartiment_id: this.activeAccess?.id_compartiment,
                compartiment_name: this.activeAccess?.denumire_compartiment || undefined,
                document_generat_id: doc.id_document,
                document_registratura_id: this.passedDocId,
                document_validare_id: signature.id,
                doc_exemplar_type: doc.doc_type_active === 2 ? 'cetatean' : 'operator'
            };

            // 2. Inițiază log-ul
            const logId = await this.operatorSignService.initiateLog(logData).toPromise() || 0;

            // 3. Obține documentul pentru semnare
            // În zona b.1 (flux), documentul e deja încărcat de Intocmitor
            // - order=0: ia din wpl_documente_generate.file_signed (sau file_signed_ex_cetatean)
            // - order>0: ia ultimul document semnat din validări
            const documentBlob = await this.getLastSignedDocument(doc.id_document, doc.doc_type_active);

            // 4. Deschide modalul pentru poziția semnăturii
            const documentUrl = URL.createObjectURL(documentBlob);

            const dialogRef = this.dialog.open(SignaturePositionModalComponent, {
                minHeight: '80vh',
                maxHeight: '90vh',
                minWidth: '900px',
                maxWidth: '95vw',
                disableClose: true,
                data: {
                    documentUrl: documentUrl,
                    documentId: doc.id_document
                }
            });

            dialogRef.afterClosed().subscribe(async (result: any) => {
                URL.revokeObjectURL(documentUrl);

                if (result?.success && result?.selection) {
                    await this.processElectronicSignature(doc, signature, documentBlob, result.selection, logId);
                } else {
                    this.isElectronicSigningInProgress = false;
                    if (logId) {
                        this.operatorSignService.updateLog(logId, {
                            status: 'failed',
                            error_message: 'Operatorul a anulat selectarea poziției semnăturii'
                        }).subscribe();
                    }
                }
            });

        } catch (error: any) {
            this.isElectronicSigningInProgress = false;
            console.error('Eroare la inițierea semnării electronice:', error);
            this.toastService.openToast({ type: 'error', message: 'Eroare la inițierea semnării electronice: ' + (error.message || 'Eroare necunoscută'), title: 'Eroare' });
        }
    }

    /**
     * Zona b.2 - Prima semnare (Intocmitor)
     * Flux îmbunătățit cu dialog de confirmare pentru doc_type=2
     * Dacă exemplarul intern e deja semnat, sare direct la cetățean
     */
    async openElectronicSignatureFirst(row: any): Promise<void> {
        if (this.isElectronicSigningInProgress) {
            this.toastService.openToast({ type: 'warning', message: 'Așteptați finalizarea operațiunii curente de semnare.', title: 'Atenție' });
            return;
        }

        this.isElectronicSigningInProgress = true;
        const documentId = row.id_document;

        try {
            // CRITICAL: Refresh data și obține row-ul fresh pentru a evita date stale
            await this.refreshDocInfoAsync();
            const freshRow = this.getFreshDocumentRow(documentId);

            if (!freshRow) {
                throw new Error('Documentul nu a fost găsit. Reîncărcați pagina.');
            }

            if (freshRow.doc_type === 2) {
                // Verifică dacă exemplarul intern e deja semnat (folosind date fresh!)
                if (freshRow.file_signed_final != null && freshRow.file_signed_final_ex_cetatean == null) {
                    // Intern deja semnat - sare direct la cetățean
                    this.toastService.openToast({
                        type: 'info',
                        message: 'Exemplarul intern este deja semnat. Continuăm cu semnarea cetățeanului...',
                        title: 'Continuare'
                    });
                    await this.signDocumentExemplar(freshRow, 'cetatean');
                    this.toastService.openToast({
                        type: 'success',
                        message: 'Ambele exemplare au fost semnate cu succes!',
                        title: 'Semnare Completă'
                    });
                } else if (freshRow.file_signed_final == null) {
                    // Semnează doar exemplarul intern electronic
                    // Backend-ul va gestiona automat exemplarul cetățean (auto-generare din content_citizen sau upload)
                    await this.signDocumentExemplar(freshRow, 'operator');

                    // Refresh pentru a vedea răspunsul backend-ului
                    await this.refreshDocInfoAsync();
                    const updatedRow = this.getFreshDocumentRow(documentId);

                    if (updatedRow?.signing_step === 'in_flux') {
                        // Backend a avansat la flux (cetățean auto-generat sau deja existent)
                        this.toastService.openToast({
                            type: 'success',
                            message: 'Exemplarul intern a fost semnat electronic. Documentul avansează la flux.',
                            title: 'Semnare Completă'
                        });
                    } else {
                        // Fallback - cetățean nu s-a putut genera automat (lipsă content_citizen)
                        this.toastService.openToast({
                            type: 'info',
                            message: 'Exemplarul intern a fost semnat. Încărcați exemplarul cetățean pentru a avansa la flux.',
                            title: 'Necesită exemplar cetățean'
                        });
                    }
                } else {
                    // Ambele deja semnate
                    this.toastService.openToast({
                        type: 'info',
                        message: 'Ambele exemplare sunt deja semnate.',
                        title: 'Info'
                    });
                }
            } else {
                // Un singur exemplar (doc_type=1)
                await this.signDocumentExemplar(freshRow, 'operator');
                this.toastService.openToast({
                    type: 'success',
                    message: 'Document semnat cu succes!',
                    title: 'Finalizat'
                });
            }
        } catch (error: any) {
            // Nu afișa eroare dacă utilizatorul a anulat intenționat
            if (error.message !== 'Operatorul a anulat semnarea') {
                console.error('Eroare la semnarea electronică:', error);
                this.toastService.openToast({ type: 'error', message: 'Eroare la semnarea electronică: ' + (error.message || 'Eroare necunoscută'), title: 'Eroare' });
            }
            // Pentru anulare, nu afișa eroare - starea e deja actualizată
        } finally {
            this.isElectronicSigningInProgress = false;
            this.getDocInfo(); // Refresh la final
        }
    }

    /**
     * Semnează un exemplar specific al documentului
     */
    private async signDocumentExemplar(row: any, exemplarType: 'operator' | 'cetatean'): Promise<void> {
        // 1. Pregătește datele pentru log
        const logData: OperatorSignLogData = {
            user_id: this.currentUser?.id_user,
            user_name: this.currentUser?.name || '',
            directie_id: this.activeAccess?.id_directie,
            directie_name: this.activeAccess?.denumire_directie,
            compartiment_id: this.activeAccess?.id_compartiment,
            compartiment_name: this.activeAccess?.denumire_compartiment || undefined,
            document_generat_id: row.id_document,
            document_registratura_id: this.passedDocId,
            document_validare_id: null, // Prima semnare
            doc_exemplar_type: exemplarType
        };

        // 2. Inițiază log-ul
        const logId = await this.operatorSignService.initiateLog(logData).toPromise() || 0;

        try {
            // 3. Generează PDF din content
            const documentBlob = await this.getDocumentForSigning(
                row.id_document,
                exemplarType === 'cetatean' ? 2 : 1
            );

            // 4. Deschide modalul pentru poziția semnăturii
            const documentUrl = URL.createObjectURL(documentBlob);

            const dialogRef = this.dialog.open(SignaturePositionModalComponent, {
                minHeight: '80vh',
                maxHeight: '90vh',
                minWidth: '900px',
                maxWidth: '95vw',
                disableClose: true,
                data: {
                    documentUrl: documentUrl,
                    documentId: row.id_document
                }
            });

            const result = await dialogRef.afterClosed().toPromise();
            URL.revokeObjectURL(documentUrl);

            if (result?.success && result?.selection) {
                await this.processFirstSignature(row, exemplarType, documentBlob, result.selection, logId);
            } else {
                if (logId) {
                    this.operatorSignService.updateLog(logId, {
                        status: 'failed',
                        error_message: 'Operatorul a anulat selectarea poziției semnăturii'
                    }).subscribe();
                }
                throw new Error('Operatorul a anulat semnarea');
            }
        } catch (error: any) {
            if (logId) {
                this.operatorSignService.updateLog(logId, {
                    status: 'failed',
                    error_message: error.message || 'Eroare necunoscută',
                    error_code: error.status
                }).subscribe();
            }
            throw error;
        }
    }

    /**
     * Procesează semnătura electronică pentru flux
     */
    private async processElectronicSignature(
        doc: any,
        signature: any,
        documentBlob: Blob,
        selection: SignatureSelection,
        logId: number
    ): Promise<void> {
        try {
            // 1. Convertește blob la base64
            const pdfBase64 = await this.operatorSignService.blobToBase64(documentBlob);

            // 2. Pregătește request-ul de semnare
            const signRequest = {
                pdfBase64,
                isOperator: true,
                signatureX: selection.x,
                signatureY: selection.y,
                signatureWidth: selection.width,
                signatureHeight: selection.height,
                signaturePage: selection.pageNumber
            };

            // 3. Semnează cu serviciul local
            const signedPdf = await this.operatorSignService.signPdfWithUserSignature(signRequest);

            // 4. Convertește înapoi la Blob și uploadează
            const signedBlob = this.operatorSignService.base64ToBlob(signedPdf.signedPdfBase64);
            await this.uploadSignedDocumentToValidation(doc.id_document, signedBlob, doc.doc_type_active);

            // 5. Actualizează log cu succes
            if (logId) {
                await this.operatorSignService.updateLog(logId, {
                    status: 'success',
                    has_user_signature: true
                }).toPromise();
            }

            // 6. Afișează mesaj de succes contextual pentru flux
            this.showSigningSuccessFeedback(doc, 'flux');

            // 7. Refresh date
            this.getDocInfo();

        } catch (error: any) {
            if (logId) {
                this.operatorSignService.updateLog(logId, {
                    status: 'failed',
                    error_message: error.message || 'Eroare la semnare',
                    error_code: error.status
                }).subscribe();
            }
            throw error;
        } finally {
            this.isElectronicSigningInProgress = false;
        }
    }

    /**
     * Procesează prima semnătură (Intocmitor)
     */
    private async processFirstSignature(
        row: any,
        exemplarType: 'operator' | 'cetatean',
        documentBlob: Blob,
        selection: SignatureSelection,
        logId: number
    ): Promise<void> {
        try {
            // 1. Convertește blob la base64
            const pdfBase64 = await this.operatorSignService.blobToBase64(documentBlob);

            // 2. Pregătește request-ul de semnare
            const signRequest = {
                pdfBase64,
                isOperator: true,
                signatureX: selection.x,
                signatureY: selection.y,
                signatureWidth: selection.width,
                signatureHeight: selection.height,
                signaturePage: selection.pageNumber
            };

            // 3. Semnează cu serviciul local
            const signedPdf = await this.operatorSignService.signPdfWithUserSignature(signRequest);

            // 4. Convertește înapoi la Blob și uploadează
            const signedBlob = this.operatorSignService.base64ToBlob(signedPdf.signedPdfBase64);
            await this.uploadFirstSignedDocument(row.id_document, signedBlob, exemplarType);

            // 5. Actualizează log cu succes
            if (logId) {
                await this.operatorSignService.updateLog(logId, {
                    status: 'success',
                    has_user_signature: true
                }).toPromise();
            }

            // 6. Afișează mesaj de succes contextual
            this.showSigningSuccessFeedback(row, exemplarType);

            // 7. Refresh date
            this.getDocInfo();

        } catch (error: any) {
            if (logId) {
                this.operatorSignService.updateLog(logId, {
                    status: 'failed',
                    error_message: error.message || 'Eroare la semnare',
                    error_code: error.status
                }).subscribe();
            }
            throw error;
        }
    }

    /**
     * Afișează feedback de succes contextual pentru semnare
     * @param doc Documentul semnat
     * @param exemplarType Tipul exemplarului sau 'flux' pentru semnare în flux
     */
    private showSigningSuccessFeedback(doc: any, exemplarType: 'operator' | 'cetatean' | 'flux'): void {
        const docType = doc.doc_type;

        if (exemplarType === 'flux') {
            // Semnare în flux (validatori)
            this.toastService.openToast({
                type: 'success',
                message: 'Document aprobat și semnat electronic cu succes!',
                title: 'Semnare Flux'
            });
            return;
        }

        if (docType === 1) {
            // doc_type=1: Un singur exemplar
            this.toastService.openToast({
                type: 'success',
                message: 'Documentul a fost semnat electronic cu succes! Procesul de semnare este complet.',
                title: 'Semnare Finalizată'
            });
        } else if (docType === 2) {
            if (exemplarType === 'operator') {
                // Prima semnare (exemplar intern)
                this.toastService.openToast({
                    type: 'info',
                    message: 'Exemplarul intern a fost semnat. Urmează semnarea exemplarului pentru cetățean.',
                    title: 'Exemplar Intern Semnat'
                });
            } else if (exemplarType === 'cetatean') {
                // A doua semnare (exemplar cetățean)
                this.toastService.openToast({
                    type: 'success',
                    message: 'Ambele exemplare (intern și cetățean) au fost semnate electronic cu succes!',
                    title: 'Semnare Completă'
                });
            }
        }
    }

    /**
     * Verifică dacă operatorul poate reîncerca semnarea exemplarului cetățean pentru un document specific
     * @param doc Documentul de verificat
     */
    canRetryCetateanSigningForDoc(doc: any): boolean {
        if (!doc) {
            return false;
        }
        return doc?.doc_type === 2 &&
            doc?.doc_type_active === 2 &&
            !doc?.file_signed_final_ex_cetatean &&
            doc?.file_signed_final; // Operator exemplar must be signed
    }

    /**
     * Reîncearcă semnarea exemplarului cetățean pentru un document specific
     * @param doc Documentul pentru care se reîncearcă semnarea
     */
    async retryCetateanSigningForDoc(doc: any): Promise<void> {
        if (!this.canRetryCetateanSigningForDoc(doc)) {
            this.toastService.openToast({
                type: 'warning',
                message: 'Nu se poate reîncerca semnarea exemplarului cetățean.',
                title: 'Atenție'
            });
            return;
        }

        if (this.isElectronicSigningInProgress) {
            this.toastService.openToast({
                type: 'warning',
                message: 'Așteptați finalizarea operațiunii curente de semnare.',
                title: 'Atenție'
            });
            return;
        }

        this.isElectronicSigningInProgress = true;

        try {
            this.toastService.openToast({
                type: 'info',
                message: 'Se reia semnarea exemplarului cetățean...',
                title: 'Reîncercare'
            });
            await this.signDocumentExemplar(doc, 'cetatean');
        } catch (error: any) {
            console.error('Eroare la reîncercarea semnării cetățean:', error);
            this.toastService.openToast({
                type: 'error',
                message: 'Eroare la reîncercarea semnării: ' + (error.message || 'Eroare necunoscută'),
                title: 'Eroare'
            });
        } finally {
            this.isElectronicSigningInProgress = false;
        }
    }

    /**
     * Obține documentul pentru semnare (generează PDF din content)
     */
    private getDocumentForSigning(documentId: number, docType: number): Promise<Blob> {
        const type = docType === 2 ? 'cetatean' : 'operator';
        return this.operatorSignService.generatePdfFromContent(documentId, type).toPromise() as Promise<Blob>;
    }

    /**
     * Obține ultimul document semnat din validări
     * @param documentId ID-ul documentului
     * @param docType Tipul exemplarului (1=operator, 2=cetatean)
     */
    private getLastSignedDocument(documentId: number, docType?: number): Promise<Blob> {
        return this.dashboardService.downloadForSigning(documentId, docType).toPromise() as Promise<Blob>;
    }

    /**
     * Uploadează documentul semnat pentru validare (flux)
     */
    private async uploadSignedDocumentToValidation(documentId: number, signedBlob: Blob, docType: number): Promise<void> {
        const formData = new FormData();
        formData.append('file', signedBlob, 'signed_document.pdf');

        return new Promise((resolve, reject) => {
            this.dashboardService.fileUpload(formData).pipe(
                switchMap((result: any) => {
                    if (result?.status_code === 200 && result?.data) {
                        const validateDoc: any = {
                            files: [result.data],
                            type: 2
                        };
                        return this.dashboardService.validateDocument(documentId, 2, validateDoc);
                    }
                    throw new Error('Eroare la încărcarea fișierului');
                })
            ).subscribe({
                next: () => resolve(),
                error: (err) => reject(err)
            });
        });
    }

    /**
     * Uploadează primul document semnat (Intocmitor)
     */
    private async uploadFirstSignedDocument(documentId: number, signedBlob: Blob, exemplarType: 'operator' | 'cetatean'): Promise<void> {
        const formData = new FormData();
        formData.append('file', signedBlob, 'signed_document.pdf');

        return new Promise((resolve, reject) => {
            this.dashboardService.fileUpload(formData).pipe(
                switchMap((result: any) => {
                    if (result?.status_code === 200 && result?.data) {
                        const validateDoc: any = {
                            files: [result.data],
                            type: 1,
                            // CRITICAL: Flag pentru a indica ca este semnare electronica, nu draft upload
                            isElectronicSignature: true,
                            exemplarType: exemplarType
                        };
                        if (exemplarType === 'cetatean') {
                            validateDoc.exemplarCetatean = [result.data];
                        }
                        return this.dashboardService.validateDocument(documentId, 1, validateDoc);
                    }
                    throw new Error('Eroare la încărcarea fișierului');
                })
            ).subscribe({
                next: () => resolve(),
                error: (err) => reject(err)
            });
        });
    }

    // ==========================================
    // SIGNING STEP TRACKING METHODS
    // ==========================================

    /**
     * Verifică dacă poate începe semnarea electronică pentru un document
     * @param row Documentul de verificat
     */
    canStartElectronicSigning(row: any): boolean {
        if (!row) return false;

        const isAssigned = row.assigned_user_id === this.currentUser?.id_user;

        // Pentru doc_type=1: nu a început semnarea (file_signed null)
        if (row.doc_type === 1) {
            return isAssigned && row.file_signed == null;
        }

        // Pentru doc_type=2: nu a început semnarea (nici intern)
        return isAssigned && row.file_signed == null;
    }

    /**
     * Verifică dacă poate continua semnarea (intern semnat, cetățean nu)
     * Butonul apare doar când documentul este la intocmitor (validare_user_type == 0)
     * @param row Documentul de verificat
     */
    canContinueSigning(row: any): boolean {
        // Cetățeanul nu mai necesită semnare electronică separată de intocmitor.
        // Backend-ul auto-generează exemplarul cetățean din content_citizen la semnarea internului.
        return false;
    }

    /**
     * Returnează status text pentru exemplar
     * @param row Documentul
     * @param exemplarType Tipul exemplarului
     */
    /**
     * Dialog pentru încărcarea exemplarului cetățean (doc_type=2, intern deja uploadat)
     * Folosește Material Dialog cu design identic cu DraftValidareComponent
     */
    uploadCetateanExemplarDialog(row: any): void {
        const dialogRef = this.dialog.open(CetateanUploadComponent, {
            minHeight: 'auto',
            maxHeight: 'auto',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
            data: {
                id: row.id_document,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result?.success) {
                this.toastService.openToast({
                    type: 'success',
                    message: 'Exemplarul cetățean a fost încărcat cu succes.',
                    title: 'Succes',
                });
                this.getDocInfo();
            }
        });
    }

    /**
     * Generează exemplarul cetățean din content_citizen (doc_type=2)
     */
    generateCetateanFromContent(row: any): void {
        Swal.fire({
            title: 'Generare Exemplar Cetățean',
            text: 'Exemplarul cetățean va fi generat automat din documentul digital. Continuați?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Generează',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#28a745',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return this.dashboardService.setCetateanExemplar(row.id_document, {
                    generateFromContent: true,
                }).toPromise()
                    .catch((err: any) => {
                        let msg = 'Eroare la generare.';
                        try { msg = err.error?.errors?.message?.[0] || msg; } catch (e) {}
                        Swal.showValidationMessage(msg);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                this.toastService.openToast({
                    type: 'success',
                    message: 'Exemplarul cetățean a fost generat din documentul digital.',
                    title: 'Succes',
                });
                this.getDocInfo();
            }
        });
    }

    getExemplarStatus(row: any, exemplarType: 'intern' | 'cetatean'): string {
        if (!row) return 'Necunoscut';

        if (exemplarType === 'intern') {
            if (row.file_signed_final) return 'Finalizat ✓';
            if (row.file_signed) return 'Semnat';
            return 'Nesemnat';
        } else {
            if (row.file_signed_final_ex_cetatean) return 'Finalizat ✓';
            if (row.file_signed_ex_cetatean) return 'Semnat';
            if (row.file_signed) return 'În așteptare';
            return 'Nesemnat';
        }
    }

    /**
     * Continuă semnarea doar pentru exemplarul cetățean
     * @param row Documentul pentru care se continuă semnarea
     */
    async continueCetateanSigning(row: any): Promise<void> {
        if (this.isElectronicSigningInProgress) {
            this.toastService.openToast({
                type: 'warning',
                message: 'Așteptați finalizarea operațiunii curente.',
                title: 'Atenție'
            });
            return;
        }

        this.isElectronicSigningInProgress = true;
        const documentId = row.id_document;

        try {
            // Refresh data și obține row-ul fresh
            await this.refreshDocInfoAsync();
            const freshRow = this.getFreshDocumentRow(documentId);

            if (!freshRow || !this.canContinueSigning(freshRow)) {
                this.toastService.openToast({
                    type: 'warning',
                    message: 'Nu se poate continua semnarea pentru acest document.',
                    title: 'Atenție'
                });
                return;
            }

            this.toastService.openToast({
                type: 'info',
                message: 'Continuăm cu semnarea exemplarului cetățean...',
                title: 'Semnare'
            });

            await this.signDocumentExemplar(freshRow, 'cetatean');

            this.toastService.openToast({
                type: 'success',
                message: 'Ambele exemplare au fost semnate cu succes!',
                title: 'Finalizat'
            });

        } catch (error: any) {
            // Nu afișa eroare dacă utilizatorul a anulat intenționat
            if (error.message !== 'Operatorul a anulat semnarea') {
                this.toastService.openToast({
                    type: 'error',
                    message: error.message || 'Eroare la semnare',
                    title: 'Eroare'
                });
            } else {
                this.toastService.openToast({
                    type: 'info',
                    message: 'Semnarea a fost anulată. Puteți relua oricând.',
                    title: 'Anulat'
                });
            }
        } finally {
            this.isElectronicSigningInProgress = false;
            this.getDocInfo(); // Refresh
        }
    }

    /**
     * Descarcă exemplar semnat specific
     * @param row Documentul
     * @param exemplarType Tipul exemplarului
     */
    downloadSignedExemplar(row: any, exemplarType: 'intern' | 'cetatean'): void {
        if (!row) return;

        const docType = exemplarType === 'cetatean' ? 2 : 1;

        // Folosește endpoint-ul pentru download oficial semnat
        this.dashboardService.downloadOfficialSigned(row.id_document, docType).subscribe({
            next: (blob: Blob) => {
                const fileName = `doc_${row.id_document}_${exemplarType}_semnat.pdf`;
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            },
            error: (err: any) => {
                this.toastService.openToast({
                    type: 'error',
                    message: 'Eroare la descărcare: ' + (err.message || 'Eroare necunoscută'),
                    title: 'Eroare'
                });
            }
        });
    }

    /**
     * Dialog de confirmare pentru continuarea semnării cetățean
     */
    private async confirmCetateanSigning(): Promise<boolean> {
        return new Promise((resolve) => {
            Swal.fire({
                title: 'Continuare Semnare',
                text: 'Exemplarul intern a fost semnat cu succes. Doriți să continuați cu semnarea exemplarului cetățean?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Da, continuă',
                cancelButtonText: 'Nu, mai târziu',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#6c757d'
            }).then((result) => {
                resolve(result.isConfirmed);
            });
        });
    }

    // ==================== VERIFICĂRI ASIGNARE DOCUMENTE GENERATE ==================== //

    /**
     * Verifică dacă utilizatorul curent poate gestiona asignarea documentului generat
     * Condiții:
     * 1. Admin override - are permisiunea specială (Șef Serviciu/tehnic)
     * 2. Este pe o activitate activă (destination_user_id sau în compartimentul destinație)
     * 3. SAU este asignat direct pe documentul generat (assigned_user_id)
     */
    canManageDocumentAssignment(row: any): boolean {
        const currentUserId = this.currentUser?.id_user;
        if (!currentUserId) return false;

        // 0. Admin override - permisiune specială pentru Șef Serviciu/tehnic
        // Permite schimbarea asignării chiar dacă operatorul e în CO
        if (this.checkPermissionFromView('indoc-module.registratura_documents.generabile.assignment-override')) {
            return true;
        }

        // 1. Verifică dacă e asignat pe documentul generat
        if (row.assigned_user_id == currentUserId) {
            return true;
        }

        // 2. Verifică dacă e pe o activitate activă (nefinalizată)
        const activeActivity = this.activityData?.find(activity =>
            activity.active === 1 &&
            activity.validated_date === null &&
            (
                activity.destination_user_id == currentUserId ||
                // Sau e în compartimentul destinație și nu e asignat pe alt user
                (activity.destination_compartiment_id == this.activeAccess?.id_compartiment &&
                    !activity.destination_user_id)
            )
        );

        if (activeActivity) {
            return true;
        }

        // NOTE: id_user_assigned nu există în docData - verificarea se face doar pe row.assigned_user_id
        return false;
    }

    // ==================== FINALIZARE DOCUMENTE GENERATE - FLUX SRP ==================== //

    /**
     * Get serviciu_registratura ID from generalData
     */
    get serviciu_registratura_id(): number {
        const config = this.generalData?.find(item => item.name === 'serviciu_registratura');
        return config ? parseInt(config.value, 10) : 0;
    }

    /**
     * Check if current user is from SRP compartment
     */
    isSRPUser(): boolean {
        return this.activeAccess?.id_compartiment == this.serviciu_registratura_id;
    }

    /**
     * Finalize document generat (for Intrare/Intern)
     */
    finalizeDocumentGenerat(row: any): void {
        Swal.fire({
            title: 'Confirmare Finalizare',
            text: 'Sigur doriți să finalizați acest document? Activitatea va fi închisă.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, finalizează',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#28a745'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.finalizeDocument(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: 'Document finalizat cu succes',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la finalizare document',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Finalize document generat directly (for Ieșire - special cases without SRP)
     */
    finalizeDocumentGeneratDirect(row: any): void {
        Swal.fire({
            title: 'Finalizare Directă',
            text: 'Sigur doriți să finalizați direct acest document fără a-l trimite la Serviciul Relații cu Publicul? Aceasta opțiune este pentru cazuri speciale.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, finalizează direct',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#ffc107'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.finalizeDocument(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: 'Document finalizat cu succes',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la finalizare document',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Send document to SRP (for Ieșire)
     */
    sendDocumentToSRP(row: any): void {
        Swal.fire({
            title: 'Trimite la SRP',
            text: 'Sigur doriți să trimiteți documentul la Serviciul Relații cu Publicul pentru înregistrare și aplicare sigiliu?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, trimite la SRP',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#007bff'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.sendToSRP(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: 'Document trimis la SRP cu succes. Operatorii SRP au fost notificați.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la trimitere către SRP',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Finalize SRP procedure (for SRP users)
     */
    finalizeSRPProcedure(row: any): void {
        Swal.fire({
            title: 'Finalizare Procedură SRP',
            text: 'Sigur doriți să finalizați procedura SRP? Operatorul inițial va fi notificat pentru continuarea procesului de predare.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, finalizează SRP',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#28a745'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.finalizeSRPProcedure(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: 'Procedură SRP finalizată. Operatorul inițial a fost notificat.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la finalizare procedură SRP',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    // ============================================
    // RESET OPERATIONS - Necesită permisiuni speciale
    // ============================================

    /**
     * Reset finalizare document - revine la in_flux
     * Permisiune: indoc-module.registratura_documents.generabile.reset-finalize
     */
    resetFinalize(row: any): void {
        Swal.fire({
            title: 'Reset Finalizare',
            text: 'Sigur doriți să resetați finalizarea? Documentul va reveni la starea "În flux".',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, resetează',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#dc3545'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.resetFinalize(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: res.message || 'Finalizare resetată cu succes.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la reset finalizare',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Reset trimitere SRP - revine la in_flux și șterge activitatea SRP
     * Permisiune: indoc-module.registratura_documents.generabile.reset-send-to-srp
     */
    resetSendToSRP(row: any): void {
        Swal.fire({
            title: 'Reset Trimitere SRP',
            text: 'Sigur doriți să resetați trimiterea la SRP? Activitatea SRP va fi ștearsă și documentul va reveni la starea "În flux".',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, resetează',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#dc3545'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.resetSendToSRP(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: res.message || 'Trimitere SRP resetată cu succes.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la reset trimitere SRP',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Reset finalizare SRP - revine la pending_srp
     * Permisiune: indoc-module.registratura_documents.generabile.reset-finalize-srp
     */
    resetFinalizeSRP(row: any): void {
        Swal.fire({
            title: 'Reset Finalizare SRP',
            text: 'Sigur doriți să resetați finalizarea SRP? Documentul va reveni la starea "La SRP" pentru reprelucrare.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, resetează',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#dc3545'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.resetFinalizeSRP(row.id_document).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: res.message || 'Finalizare SRP resetată cu succes.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la reset finalizare SRP',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Verifică dacă utilizatorul curent poate edita documentul
     * @param row Document row data
     * @returns true dacă utilizatorul poate edita
     */
    canEditDocument(row: any): boolean {
        // Verifică dacă utilizatorul este asignat pe document
        return row.assigned_user_id === this.currentUser?.id_user;
    }

    // =========================================================================
    // Circuit Redactare - Metode pentru acțiuni inline
    // =========================================================================

    /**
     * Verifică dacă este rândul utilizatorului curent pentru redactare
     */
    isMyTurnRedaction(red: any, row: any): boolean {
        if (!red || !row || !this.currentUser) return false;
        if (red.order !== row.redaction_current_order) return false;
        if (red.type !== 0) return false; // Doar dacă e în așteptare (pending)

        // Dacă există specific_user_id, verifică exact acel user
        if (red.specific_user_id) {
            return red.specific_user_id === this.currentUser.id_user;
        }

        // Verifică dacă user_type (functie_id) corespunde cu funcția activă a utilizatorului
        if (red.user_type) {
            const myFunctieId = this.activeFunction?.functie_id;
            if (!myFunctieId || red.user_type !== myFunctieId) return false;
        }

        // Verifică dacă direcția corespunde (dacă e specificată pe redactare)
        if (red.directie_id) {
            const myDirectieId = this.activeAccess?.id_directie;
            if (!myDirectieId || red.directie_id !== myDirectieId) return false;
        }

        // Verifică dacă compartimentul corespunde (dacă e specificat pe redactare)
        if (red.compartiment_id) {
            const myCompartimentId = this.activeAccess?.id_compartiment;
            if (!myCompartimentId || red.compartiment_id !== myCompartimentId) return false;
        }

        // Dacă există user_id specific (diferit de specific_user_id), verifică
        if (red.user_id) {
            return red.user_id === this.currentUser.id_user;
        }

        return true;
    }

    /**
     * Returnează label-ul pentru status redactare
     */
    getRedactionStatusLabel(red: any): string {
        if (!red) return 'Necunoscut';
        switch (red.type) {
            case 0: return 'În așteptare';
            case 1: return 'Aprobat';
            case 2: return 'Respins';
            default: return 'Necunoscut';
        }
    }

    /**
     * Aprobă redactarea curentă (aprobare virtuală fără upload)
     */
    approveRedaction(red: any, row: any): void {
        Swal.fire({
            title: 'Aprobare Redactare',
            text: 'Confirmați aprobarea acestui pas din circuitul de redactare?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, aprobă',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#28a745'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.processRedactionStep(row.id_document, red.id, {
                    observations: null
                }).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: res.data?.message || 'Redactare aprobată cu succes.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la aprobare redactare',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    /**
     * Retrimite documentul la întocmitor cu motiv
     */
    sendBackToCreator(red: any, row: any): void {
        Swal.fire({
            title: 'Retrimite la Întocmitor',
            html: `
                <p>Introduceți motivul retrimiterii:</p>
                <textarea id="swal-reason" class="swal2-textarea" style="width: 100%; min-height: 100px;" placeholder="Motivul retrimiterii..."></textarea>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Retrimite',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#ffc107',
            preConfirm: () => {
                const reason = (document.getElementById('swal-reason') as HTMLTextAreaElement).value;
                if (!reason || reason.trim().length === 0) {
                    Swal.showValidationMessage('Vă rugăm introduceți un motiv');
                    return false;
                }
                return { reason: reason.trim() };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                this.dashboardService.sendBackToCreator(row.id_document, {
                    reason: result.value.reason
                }).subscribe({
                    next: (res: any) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.success,
                            message: res.data?.message || 'Document retrimis la întocmitor.',
                            type: this.helper.dialogConfig.icons.success,
                        });
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.toastService.openToast({
                            title: this.helper.dialogConfig.headers.error,
                            message: err.error?.error || 'Eroare la retrimitere',
                            type: this.helper.dialogConfig.icons.error,
                        });
                    }
                });
            }
        });
    }

    // ==========================================
    // Redactare - actualizare redactor curent
    // ==========================================

    editRedactari(event: any, row: any = null): void {
        this.showEditRedactari = !this.showEditRedactari;

        if (row !== null && this.showEditRedactari === true) {
            // Preselectăm redactorul curent
            const currentRedaction = row.redactari?.find((r: any) => r.order === row.redaction_current_order);
            this.selectedRedactor = currentRedaction?.user_type || -1;
        }
    }

    onRedactorSelect(): void {
        // Placeholder pentru eventuale acțiuni la selectare
        console.log('Redactor selectat:', this.selectedRedactor);
    }

    updateRedactorCurent(row: any): void {
        if (!this.selectedRedactor || this.selectedRedactor === -1) {
            return;
        }

        // Găsim redactorul selectat pentru a obține order-ul
        const selectedRedaction = row.redactari?.find((r: any) => r.user_type === this.selectedRedactor);
        if (!selectedRedaction) {
            this.notificationService.warningSwal(
                this.helper.dialogConfig.headers.error,
                'Nu s-a putut găsi redactorul selectat.',
                'error'
            );
            return;
        }

        // Apelăm endpoint-ul pentru actualizare redactor curent
        this.dashboardService.updateCurrentRedactor(row.id_document, {
            redaction_id: selectedRedaction.id,
            new_order: selectedRedaction.order
        }).subscribe({
            next: (res: any) => {
                this.notificationService.successSwal(
                    this.helper.dialogConfig.headers.success,
                    'Redactorul curent a fost actualizat cu succes!'
                );
                this.showEditRedactari = false;
                this.selectedRedactor = -1;
                this.getDocInfo();
            },
            error: (err) => {
                this.notificationService.warningSwal(
                    this.helper.dialogConfig.headers.error,
                    err.error?.error || 'Eroare la actualizarea redactorului curent',
                    'error'
                );
            }
        });
    }

    /**
     * Verifică dacă redactarea e în curs (pending sau in_progress)
     * Folosit pentru a ascunde butoanele de Aprobare/Semnare când documentul e în redactare
     */
    isRedactionInProgress(row: any): boolean {
        if (!row) return false;
        const step = row.redaction_step;
        return step === 'pending' || step === 'in_progress';
    }

    /**
     * Pornește circuitul de redactare (trece din 'pending' în 'in_progress')
     */
    startRedactionCircuit(row: any): void {
        Swal.fire({
            title: 'Start Redactare',
            text: 'Confirmați pornirea circuitului de redactare? Documentul va intra în procesul de redactare.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Da, pornește',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#f0ad4e'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.startRedactionCircuit(row.id_document).subscribe({
                    next: (res: any) => {
                        this.notificationService.successSwal(
                            this.helper.dialogConfig.headers.success,
                            'Circuitul de redactare a fost pornit!'
                        );
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.notificationService.warningSwal(
                            this.helper.dialogConfig.headers.error,
                            err.error?.error || err.error?.message || 'Eroare la pornirea circuitului de redactare',
                            'error'
                        );
                    }
                });
            }
        });
    }

    /**
     * Verifică dacă se poate activa/dezactiva circuitul de redactare
     * - Dezactivare permisă doar dacă nimeni NU a procesat încă (toate redactările sunt type=0 pending)
     * - Activare permisă oricând dacă nu există circuit activ
     */
    canToggleRedaction(row: any): boolean {
        // Nu mai permitem toggle dacă documentul a fost încărcat/semnat electronic
        // (file_signed există = pasul de upload a fost completat)
        if (row.file_signed) {
            return false;
        }

        // Dacă nu există circuit activ, se poate activa
        if (!row.redaction_step || row.redaction_step === 'none') {
            return true;
        }

        // Dacă există circuit, verificăm dacă toate stepurile sunt pending (type=0)
        // Nu permitem dezactivarea dacă cineva a procesat deja (type=1 sau type=2)
        if (row.redactari && row.redactari.length > 0) {
            const hasProcessedStep = row.redactari.some((r: any) => r.type !== 0);
            return !hasProcessedStep; // Poate dezactiva doar dacă nimeni nu a procesat
        }

        return true;
    }

    /**
     * Toggle activare/dezactivare circuit redactare
     */
    toggleRedactionActive(row: any): void {
        const isActive = row.redaction_step && row.redaction_step !== 'none';
        const actionText = isActive ? 'dezactiva' : 'activa';
        const confirmText = isActive ? 'Da, dezactivează' : 'Da, activează';

        if (isActive) {
            // Dezactivare - cerem motiv
            Swal.fire({
                title: 'Dezactivare Circuit Redactare',
                html: `
                    <p>Introduceți motivul dezactivării (opțional):</p>
                    <textarea id="swal-reason" class="swal2-textarea" placeholder="Motivul dezactivării..."></textarea>
                `,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: confirmText,
                cancelButtonText: 'Anulează',
                confirmButtonColor: '#dc3545',
                preConfirm: () => {
                    return (document.getElementById('swal-reason') as HTMLTextAreaElement)?.value || '';
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.executeToggleRedaction(row, false, result.value);
                }
            });
        } else {
            // Activare - confirmare simplă
            Swal.fire({
                title: 'Activare Circuit Redactare',
                text: 'Confirmați activarea circuitului de redactare pentru acest document?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: confirmText,
                cancelButtonText: 'Anulează',
                confirmButtonColor: '#28a745'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.executeToggleRedaction(row, true, null);
                }
            });
        }
    }

    private executeToggleRedaction(row: any, active: boolean, reason: string | null): void {
        this.dashboardService.toggleRedactionActive(row.id_document, {
            active: active,
            reason: reason || undefined
        }).subscribe({
            next: (res: any) => {
                this.notificationService.successSwal(
                    this.helper.dialogConfig.headers.success,
                    active ? 'Circuitul de redactare a fost activat.' : 'Circuitul de redactare a fost dezactivat.'
                );
                this.getDocInfo();
            },
            error: (err) => {
                this.notificationService.warningSwal(
                    this.helper.dialogConfig.headers.error,
                    err.error?.error || 'Eroare la modificarea stării circuitului de redactare',
                    'error'
                );
            }
        });
    }

    /**
     * Verifică dacă un pas de redactare poate fi resetat
     * - Doar pașii procesați (type=1 done sau type=2 rejected) pot fi resetați
     * - Doar dacă utilizatorul are permisiune de management SAU e pasul lui procesat anterior
     * - NU permite reset când circuitul e complet
     */
    canResetRedaction(red: any, row: any): boolean {
        if (!red || !row) return false;

        // Nu permite reset când circuitul e complet
        if (row.redaction_step === 'complete') return false;

        // Doar pașii procesați pot fi resetați
        if (red.type !== 1 && red.type !== 2) return false;

        // Verifică dacă e admin/manager
        if (this.canManageDocumentAssignment(row)) {
            return true;
        }

        // Verifică dacă e pasul utilizatorului curent (procesat de el anterior)
        if (red.user_id === this.currentUser?.id_user) {
            return true;
        }

        // Verifică dacă e specific_user_id
        if (red.specific_user_id === this.currentUser?.id_user) {
            return true;
        }

        return false;
    }

    /**
     * Resetează un pas de redactare procesat la starea pending
     */
    resetRedactionStep(red: any, row: any): void {
        Swal.fire({
            title: 'Reset Pas Redactare',
            html: `
                <p>Sunteți sigur că doriți să resetați acest pas?</p>
                <p class="text-muted">Pasul va reveni în starea "În așteptare" și va trebui procesat din nou.</p>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, resetează',
            cancelButtonText: 'Anulează',
            confirmButtonColor: '#6c757d'
        }).then((result) => {
            if (result.isConfirmed) {
                this.dashboardService.resetRedactionStep(row.id_document, red.id).subscribe({
                    next: (res: any) => {
                        this.notificationService.successSwal(
                            this.helper.dialogConfig.headers.success,
                            'Pasul de redactare a fost resetat cu succes!'
                        );
                        this.getDocInfo();
                    },
                    error: (err) => {
                        this.notificationService.warningSwal(
                            this.helper.dialogConfig.headers.error,
                            err.error?.error || 'Eroare la resetarea pasului de redactare',
                            'error'
                        );
                    }
                });
            }
        });
    }
}
